<template>
  <div class="row enrollment-list course-enrollment-list">
    <div
      :class="{
        'col-12': !showDetailsPane,
        'col-8 details-pane-open': showDetailsPane,
      }"
    >
      <ListTable
        :items="items"
        :columns="columns"
        :activeColumns="activeColumns"
        :hideNoResults="hideNoResults"
        :hasDetailsPane="showDetailsPane"
        @sort-by="setSort"
        @swap-column="setActiveColumn"
      >
        <template v-slot:col_cost="{ item }">{{ item.cost | cost }}</template>
        <template v-slot:col_enrolled_at="{ item }">{{
          item.enrolled_at | moment("MM/DD/YYYY")
        }}</template>
        <template v-slot:col_completed_at="{ item }">{{
          item.completed_at | moment("MM/DD/YYYY")
        }}</template>
        <template v-slot:list-card="{ item, id }">
          <EnrollmentCard
            :item="item"
            :id="id"
            :eventBus="listEvents"
            :section="section"
          />
        </template>
        <template v-slot:list-menu="{ item, id }">
          <EnrollmentMenu
            :item="item"
            :id="id"
            :eventBus="listEvents"
            :section="section"
          />
        </template>
      </ListTable>
    </div>
    <div v-if="showDetailsPane" class="col-4 details-pane-wrap mb-3">
      <UserDetailsPane
        v-if="!!selectedUser"
        :user="selectedUser"
        @close="hideDetailsPane"
      />
      <CourseDetailsPane
        v-if="!!selectedCourse"
        :course="selectedCourse"
        :enrollment="selectedEnrollment"
        :section="section"
        @close="hideDetailsPane"
      />
    </div>
  </div>
</template>

<script>
import ListTable from "components/listings/Table";
import EnrollmentCard from "./EnrollmentCard";
import EnrollmentMenu from "./EnrollmentMenu";
import UserDetailsPane from "../Users/DetailsPane";
import CourseDetailsPane from "./DetailsPane";

export default {
  components: {
    ListTable,
    EnrollmentCard,
    EnrollmentMenu,
    UserDetailsPane,
    CourseDetailsPane,
  },
  props: {
    section: { type: String, default: "training" },
    items: { type: Array, default: () => [] },
    columns: { type: Array, default: () => [] },
    activeColumns: { type: Array, default: () => [] },
    hideNoResults: { type: Boolean, default: true },
    listEvents: { type: Object, required: true },
  },
  data() {
    return {
      selectedEnrollment: null,
      selectedUser: null,
      selectedCourse: null,
    };
  },
  computed: {
    showDetailsPane() {
      return !!this.selectedUser || !!this.selectedCourse;
    },
  },
  methods: {
    handleMenuAction(action, item) {
      this.selectedEnrollment = item;
      if (action == "show-user-details") {
        this.selectedCourse = null;
        this.selectedUser = item.user;
      } else if (action == "show-course-details") {
        this.selectedUser = null;
        this.selectedCourse = item.enrollable;
      }
    },
    setSort(column, dir) {
      this.$emit("sort-by", column, dir);
    },
    setActiveColumn(column, index) {
      this.$emit("swap-column", column, index);
    },
    hideDetailsPane() {
      this.selectedEnrollment = null;
      this.selectedCourse = null;
      this.selectedUser = null;
    },
  },
  mounted() {
    this.listEvents.$on("menu-action", this.handleMenuAction);
  },
};
</script>